import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MfaCodeInput from 'components/molecules/MfaCodeInput';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Steps = styled.ol`
  margin: 0;
  padding-left: 21px;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.main};
`;

const QrWrapper = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: 8px;
  padding: 16px;
  max-width: 200px;
  margin: 0 auto;
`;

const QrImage = styled.img`
  width: 100%;
  height: auto;
`;

const CodeSection = styled.div`
  display: flex;
  justify-content: center;
`;

const ManualKey = styled.p`
  margin: 16px 0 0 0;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.subtle};
  text-align: center;
  word-break: break-word;
`;

const ManualKeyValue = styled.span`
  font-family: monospace;
  color: ${({ theme }) => theme.colors.text.subtle};
`;

const MfaSetupSteps = ({ setupData, onSubmit, dataCyPrefix }) => (
  <Content>
    <StepBlock>
      <Steps>
        <li>Scan the QR code below in your authenticator app (Google Authenticator, Okta Verify, Authy...):</li>
      </Steps>
      <QrWrapper>
        <QrImage src={setupData.qrCode} alt="Two-factor authentication QR code" />
      </QrWrapper>
    </StepBlock>
    <StepBlock>
      <Steps start={2}>
        <li>Enter the code from your authenticator app below:</li>
      </Steps>
      <CodeSection>
        <MfaCodeInput allowBackupCode={false} onSubmit={onSubmit} dataCyPrefix={dataCyPrefix} />
      </CodeSection>
    </StepBlock>
    <ManualKey>
      Unable to scan? Enter this setup key manually: <ManualKeyValue>{setupData.secret}</ManualKeyValue>
    </ManualKey>
  </Content>
);

MfaSetupSteps.propTypes = {
  setupData: PropTypes.shape({
    qrCode: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  dataCyPrefix: PropTypes.string,
};

MfaSetupSteps.defaultProps = {
  dataCyPrefix: undefined,
};

export default MfaSetupSteps;
